import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TherapistService {

    constructor(
        private http: HttpClient,
    ) {
    }

    getMeasurements() {
        return this.http.get(`${environment.apiUrl}/storage/measurements`);
    }

    isTherapistApp() {
        return environment.isLocal ? true : window.location.href.includes('therapist');
    }
}
